import { IconButton } from '@mui/material'
import React, { useState } from 'react'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import MySortMenu from './MySortMenu';

const MySortHeadField = ({ text, menuList, fieldSlug, field, setField, type, setType }) => {

    const [menuAnchor, setMenuAnchor] = useState(null)
    const [activeColumn, setActiveColumn] = useState(null)

    const [sort, setSort] = useState({
        field: '',
        type: '' // asc | desc | numberAsc | numberDesc | custom | reset
    })

    const handleOpenMenu = (e, columnId) => {
        setMenuAnchor(e.currentTarget)
        setActiveColumn(columnId)
    }

    const handleChooseSort = (type) => {
        if (type === 'reset') { // Якщо скидання
            if (activeColumn === fieldSlug && activeColumn === field) { // Скидаємо лише, якщо скидається саме те поле, по якому було сортування
                console.log('activeColumn, fieldSlug', activeColumn, fieldSlug)
                console.log('type', type)
                setSort({ field: activeColumn, type })
                setField(activeColumn)
                setType(type)
            }
        } else {
            setSort({ field: activeColumn, type })
            setField(activeColumn)
            setType(type)
        }
        
        setMenuAnchor(null)
    }

  return (
    // <TableCell align="center">
        <div className='myTable__sortField'>
            {text}
            <IconButton
                size="small" 
                onClick={(e) => handleOpenMenu(e, fieldSlug)}
                sx={{
                    color: field === fieldSlug && type !== 'reset' ? '#27AE60' : ''
                }}
            >
                <ArrowDropDownIcon fontSize="small"/>
            </IconButton>
            <MySortMenu 
                menuAnchor={menuAnchor}
                setMenuAnchor={setMenuAnchor}
                handleChooseSort={handleChooseSort}
                menuList={menuList}
            />
        </div>
    // </TableCell>
  )
}

export default MySortHeadField